export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MenuItemsSearchResults.vue?vue&type=template&id=eda9a7c8&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/MenuItemsSearchResults.vue?vue&type=template&id=eda9a7c8&scoped=true&
// module id = 2417
// module chunks = 5